import './style.scss';

export default !function () {
  const playButton = document.querySelector('.video-v2__content');

  if (playButton) {
    playButton.addEventListener('click', () => {
      window.$analytics && window.$analytics.push('trailer-show');
    });
  }
}();
